import { render, staticRenderFns } from "./index-property.vue?vue&type=template&id=31825944&scoped=true"
import script from "./index-property.vue?vue&type=script&lang=js"
export * from "./index-property.vue?vue&type=script&lang=js"
import style0 from "./index-property.vue?vue&type=style&index=0&id=31825944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31825944",
  null
  
)

export default component.exports